import { atom } from 'recoil';

export const userLocationState = atom({
    key: 'userLocationState',
    default: {
        latitude: 0,
        longitude: 0,
    },
});

export const pinsFiltersState = atom({
    key: 'pinsFiltersState',
    default: {
        tags: [],
        ownerIds: [],
    },
    effects_UNSTABLE: [
        ({ onSet, setSelf }) => {
            const saved = localStorage.getItem('pinsFiltersState');
            if (saved) {
                setSelf(JSON.parse(saved));
            }
            onSet((newValue) => {
                localStorage.setItem('pinsFiltersState', JSON.stringify(newValue));
            });
        },
    ],
});

export const tokenState = atom({
    key: 'tokenState',
    default: localStorage.getItem('tokenState'),
});

export const splashLoadersSate = atom({
    key: 'splashLoadersSate',
    default: [],
});


export const splashSharedDataState = atom({
    key: 'splashSharedDataState',
    default: {
        name: '',
        author: '',
        source: '',
    },
});

export const proViewState = atom({
    key: 'proViewState',
    default: localStorage.getItem('tokenState') ? localStorage.getItem('proView') === 'true' : false,
});

export const socialShareState = atom({
    key: 'socialShareState',
    default: null,
});

export const usePaginatedDataState = atom({
    key: 'usePaginatedDataState',
    default: false,
});

export const globalDataState = atom({
    key: 'globalDataState',
    default: {
        pins: [],
        tags: [],
        tasks: [],
        users: [],
        routes: [],
        profile: {},
        zones: [],
        loading: true,
        organization: {},
    },
});
